import { createSelector } from '@ngrx/store';

import { selectTenantState } from '../reducers';
import { TenantState } from '../reducers/tenant.reducers';
import { UserDTO } from '../../commons/models/user.model';
import { TenantsDTO } from '../../commons/models/tenants';
import { getCurrentUser } from './auth.selectors';

// Tenant Selectors

export const getTenantsTableState = createSelector(
  selectTenantState,
  (state: TenantState) => { return { total: state.total, currentPage: state.currentPage, perPage: state.perPage, order: state.order, direction: state.direction, filters: state.filters, includes: state.includes } }
);

export const getTenants = createSelector(
  selectTenantState,
  (state: TenantState) => state.list
);

export const getFilteredTenants = createSelector(
  getTenants,
  getCurrentUser,
  (tenants: TenantsDTO[], user: UserDTO) => {

    if (!user) {
      console.log('Nessun utente trovato, nessun tenant disponibile.');
      return [];
    }

    const userRoles = user.user_roles || [];

    if (!tenants || tenants.length === 0) {
      return [];
    }

    if (userRoles.includes('admin')) {
      //console.log('Admin: restituisco tutti i tenants.');
      return tenants;
    }

    if (userRoles.includes('manager')) {
      const filteredTenants = tenants.filter(tenant =>
        user.tenants?.some(t => t.id === tenant.id)
      );
      //console.log('Manager: restituisco solo i tenants associati.');
      return filteredTenants;
    }

    console.log('Nessun tenant trovato.');
    return [];
  }
);




export const getTotalTenants = createSelector(
  getTenantsTableState,
  (tableState) => tableState.total
);

export const getTenantsCurrentPage = createSelector(
  getTenantsTableState,
  (tableState) => tableState.currentPage
);

export const getTenantsPerPage = createSelector(
  getTenantsTableState,
  (tableState) => tableState.perPage
);

export const getTenantsOrder = createSelector(
  getTenantsTableState,
  (tableState) => tableState.order
);

export const getTenantsDirection = createSelector(
  getTenantsTableState,
  (tableState) => tableState.direction
);

export const getFilters = createSelector(
  getTenantsTableState,
  (tableState) => tableState.filters
);

export const getTenantDialogId = createSelector(
  selectTenantState,
  (state: TenantState) => state.dialogId
);

export const getSelectedStoreTenant = createSelector(
  selectTenantState,
  (state: TenantState) => {
    return state.selectedStoreTenant || null;
  }
);


export const getSelectionDialogId = createSelector(
  selectTenantState,
  (state: TenantState) => state.selectionDialogId
);

// export const getSelectedTenantsCurrentPage = createSelector(
//   selectTenantState,
//   (state: TenantState) => {
//     const selectedIds = state.selectedTenants.map(bl => bl.id);
//     return state.list?.filter(bl => selectedIds.includes(bl.id));
//   }
// );
